import { useState, useRef } from "react";
import { useInView } from "../../components/inView/inView";
import "./footer.css";

export default function Footer({ onSelect, activePage }) {

    useInView();


    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);



    const handleClick = (e) => {
        e.preventDefault();
        const menu = menuRef.current;

        if (menu) {
            menu.classList.add("slideUp");
            setOpen(false);
            setTimeout(() => {
                menu.classList.remove("slideUp");
            }, 1000);
        }
    };

    return (

        <div className="footer-container" data-animation='{"once": false, "delay":0}' >
            <div className="footer">
                <div><p>© 2025 Ricardo Beaujon</p></div>
                <nav className={`nav-links link-right ${open ? "show" : ""}`}>
                    <div id="links">
                        <li> <a href="#!" onClick={(e) => { handleClick(e); onSelect("about"); window.scrollTo({ top: 0, behavior: "smooth" }); }} className={activePage === "about" ? "active" : ""} >About</a></li>
                        <li><a href="#!" onClick={(e) => { handleClick(e); onSelect("skills"); window.scrollTo({ top: 0, behavior: "smooth" }); }} className={activePage === "skills" ? "active" : ""} >Skills</a></li>
                        <li><a href="#!" onClick={(e) => { handleClick(e); onSelect("portfolio"); window.scrollTo({ top: 0, behavior: "smooth" }); }} className={activePage === "portfolio" ? "active" : ""} >Portfolio</a></li>
                        <li><a href="#!" onClick={(e) => { handleClick(e); onSelect("blog"); window.scrollTo({ top: 0, behavior: "smooth" }); }} className={activePage === "blog" ? "active" : ""} >Blog</a></li>
                        <li><a href="#!" onClick={(e) => { handleClick(e); onSelect("contacts"); window.scrollTo({ top: 0, behavior: "smooth" }); }} className={activePage === "contacts" ? "active" : ""} >Contacts</a></li>
                    </div>
                </nav>
            </div>
        </div>
    );

}